package com.example.event_management_system.data.models

import kotlinx.serialization.Serializable

@Serializable
data class Event(
    val id: String = "",
    val customerName: String = "",
    val customerEmail: String = "",
    val customerPhone: String = "",
    @kotlinx.serialization.Serializable(with = LongAsDoubleSerializer::class)
    val eventDate: Long = 0L,
    val eventTime: String = "",
    val eventEndTime: String? = null,
    val guestCount: Int = 0,
    val cost: String? = null,
    val deposit: String? = null,
    val locationId: String = "",
    val locationName: String = "",
    val sectionId: String? = null,
    val sectionName: String? = null,
    val eventPurpose: String? = null,
    val catererContact: String? = null,
    val notes: String? = null,
    val postEventNotes: String? = null,
    val signatureUrl: String? = null,
    val pdfUrl: String? = null,
    val status: EventStatus = EventStatus.PENDING,
    val createdBy: String = "",
    @kotlinx.serialization.Serializable(with = LongAsDoubleSerializer::class)
    val createdAt: Long = 0L,
    @kotlinx.serialization.Serializable(with = LongAsDoubleSerializer::class)
    val updatedAt: Long = 0L,
    val isDeleted: Boolean = false
)
